import { render } from "./MetacakeChart2.vue?vue&type=template&id=701f6dab&scoped=true"
import script from "./MetacakeChart2.vue?vue&type=script&lang=ts"
export * from "./MetacakeChart2.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-701f6dab"

export default script